import constate from 'constate'
import { useParams } from 'react-router'
import { useGetOvertimeRequestByIdQuery } from '@/features/overtime/overtime.api.ts'

export const [OvertimeRequestDetailsProvider, useOvertimeRequestDetails] = constate(() => {
  const { overtimeId } = useParams() as unknown as { overtimeId: number }
  const { data, refetch, isFetching, error } = useGetOvertimeRequestByIdQuery({
    id: overtimeId,
  }, {
    skip: !overtimeId,
  })

  return {
    data: data?.details,
    viewerRole: data?.viewerRole,
    approval: data?.approval,
    refetch,
    isFetching,
    error,
  }
})
